module.exports = __webpack_public_path__ + "img/lines.5c3f2376.svg";